module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "arautos-header"
  }, [_c('center', [_c('b-img', {
    attrs: {
      "fluid": "",
      "src": "https://cdnarautos.s3.amazonaws.com/2020/08/Logos_Capa_Arautos_WEB3.png",
      "alt": "Image 1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "linha-menu"
  })], 1), _vm._v(" "), _c('b-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertSucesso),
      expression: "alertSucesso"
    }]
  }, [_c('b-media', {
    attrs: {
      "right-align": "",
      "vertical-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "aside",
      fn: function() {
        return [_c('b-img', {
          attrs: {
            "fluid": "",
            "src": "https://cdnarautos.s3.amazonaws.com/sites/21/2020/11/img-revista-02.png",
            "alt": "Image 1"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', {
    staticClass: "mt-5 mb-2"
  }, [_vm._v("Sua resposta foi enviada com sucesso!")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 mb-2"
  }, [_vm._v("\n        Clique no link e acesse o exemplar Digital da Revista Arautos do Evangelho:\n      ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://revistacatolica.com.br/"
    }
  }, [_vm._v("https://revistacatolica.com.br/")])])])], 1), _vm._v(" "), _c('b-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alertError),
      expression: "alertError"
    }]
  }, [_c('b-media', {
    attrs: {
      "right-align": "",
      "vertical-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "aside",
      fn: function() {
        return [_c('b-img', {
          attrs: {
            "fluid": "",
            "src": "https://cdnarautos.s3.amazonaws.com/sites/21/2020/11/img-revista-02.png",
            "alt": "Image 1"
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', {
    staticClass: "mt-5 mb-2"
  }, [_vm._v(_vm._s(_vm.error.message))]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 mb-2"
  }, [_vm._v("\n        Clique no link e acesse o exemplar Digital da Revista Arautos do Evangelho:\n      ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://revistacatolica.com.br/"
    }
  }, [_vm._v("https://revistacatolica.com.br/")])])])], 1), _vm._v(" "), _c('b-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.hasData),
      expression: "!loading && hasData"
    }],
    staticClass: "bv-example-row"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.tratamentoDisplay)), _c('b', [_vm._v(" " + _vm._s(_vm.user.nomeDisplay))])]), _vm._v(" "), _c('p', [_vm._v("Salve Maria!")]), _vm._v(" "), _c('p', [_vm._v("\n      Nesta página estão disponíveis as opções relativas à sua colaboração "), _c('b', [_vm._v(_vm._s(_vm.user.mesDisplay))])]), _vm._v(" "), _c('p', [_vm._v("\n      Por favor, indique-nos uma opção para que possamos registrar em nossos sistemas:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.optionSelected),
      callback: function($$v) {
        _vm.optionSelected = $$v
      },
      expression: "optionSelected"
    }
  }, [_vm._l((_vm.tabulacoes), function(option, i) {
    return [_c('el-radio', {
      key: i,
      attrs: {
        "label": option,
        "border": ""
      }
    }, [_vm._v(_vm._s(option.tabulacao))])]
  })], 2)], 1), _vm._v(" "), _c('p', [_vm._v("\n      Se tiver mais informações, utilize o campo de observações para enviar-nos uma mensagem.\n    ")]), _vm._v(" "), _c('p', [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Observação"
    },
    model: {
      value: (_vm.obs),
      callback: function($$v) {
        _vm.obs = $$v
      },
      expression: "obs"
    }
  })], 1), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirm($event)
      }
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.8em",
      "margin-top": "15px"
    }
  }, [_c('center', [_vm._v("\n      Para a sua segurança, todas os dados cadastrais não são alterados nesta página. Caso precise mudar alguma informação no seu cadastro, por favor entre em contato conosco.\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "linha-menu"
  }), _vm._v(" "), _c('b-container', [_c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center",
      "valign": "middle"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('table', {
    attrs: {
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('td', {
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "color": "#192f19",
      "padding-right": "10px"
    }
  }, [_vm._v("\n                      Fale conosco\n                    ")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "width": "123"
    }
  }, [_c('td', {
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('table', {
    attrs: {
      "width": "70%",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('td', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://cdnarautos.s3.us-east-1.amazonaws.com/social-logos/phone_PNG48992.png",
      "alt": "Ligue para o Atendimento ao Assinante",
      "width": "33",
      "height": "33"
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "padding-left": "10px",
      "color": "#192f19"
    }
  }, [_vm._v("(11) 2971-9050")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('td', {
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://cdnarautos.s3.us-east-1.amazonaws.com/social-logos/email-icon-png-email-icon-image-122-2400.png",
      "alt": "Mande um e-mail para o Atendimento ao Assinante",
      "width": "33",
      "height": "33"
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "padding-left": "10px",
      "color": "#192f19"
    }
  }, [_vm._v("admrevista@arautos.org.br")])])])])])])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "color": "#192f19"
    }
  }, [_vm._v("\n                      Mantenha-se conectado\n                    ")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    },
    attrs: {
      "width": "123"
    }
  }, [_c('td', {
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "https://revistacatolica.com.br/",
      "target": "_blank",
      "title": "Revista Arautos do Evangelho"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://cdnarautos.s3.amazonaws.com/2020/04/logo-em-baixo.png",
      "alt": "Revista Arautos do Evangelho",
      "width": "63",
      "height": "100%"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "align": "center",
      "valign": "middle"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "href": "https://www.youtube.com/user/TVArautos",
      "target": "_blank",
      "title": "Inscreva-se no canal"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "src": "https://cdnarautos.s3.us-east-1.amazonaws.com/social-logos/youtube_social_icon_red.png",
      "alt": "Inscreva-se no canal",
      "width": "43",
      "height": "100%"
    }
  })])])])])])])])])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "middle"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "padding-left": "10px",
      "padding-right": "10px",
      "color": "#1f1317",
      "font-size": "14px"
    }
  }, [_c('strong', [_vm._v("Administração: ")]), _vm._v("Rua Diogo de Brito, 41 - 02460-110 - São Paulo - SP "), _c('br'), _c('strong', [_vm._v("Atendimento ao assinante: ")]), _vm._v("nos dias úteis, de 8 às 17:00h\n                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "middle"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "padding-left": "10px",
      "padding-right": "10px",
      "color": "#1f1317",
      "font-size": "12px"
    }
  }, [_vm._v("\n                      Copyright© Revista Arautos do Evangelho 2021. Todos\n                      os direitos reservados. Divulgação autorizada, citando a\n                      fonte.\n                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "middle"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Arial, Helvetica, sans-serif",
      "padding-left": "10px",
      "padding-right": "10px",
      "color": "#1f1317",
      "font-size": "12px"
    }
  }, [_vm._v("\n                      Importante: Se não quiser receber nossas mensagens,\n                      "), _c('a', {
    staticStyle: {
      "color": "#22009d"
    },
    attrs: {
      "href": "https://revistacatolica.com.br/remover-email/",
      "target": "_blank",
      "title": "Instruções Anti-Span"
    }
  }, [_vm._v("clique aqui")]), _vm._v("\n                      para para descadastrar seu e-mail.\n                    ")])])])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-center",
      "hide-backdrop": "",
      "content-class": "shadow",
      "centered": "",
      "hide-header": "",
      "ok-only": "",
      "ok-title": "Aceitar",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "ok-variant": "dark"
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Utilizamos cookies em nosso site para oferecer uma experiência mais relevante ao lembrar suas preferências. Ao clicar em \"Aceitar\", você concorda com o uso de todos os cookies. "), _c('a', {
    attrs: {
      "href": "https://revistacatolica.com.br/politica-cookies/",
      "target": "_blank"
    }
  }, [_vm._v("Leia mais")])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-center-error",
      "hide-backdrop": "",
      "content-class": "shadow",
      "centered": "",
      "title": _vm.error.title,
      "ok-only": "",
      "hide-header": "",
      "ok-variant": "dark"
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-center-loading",
      "hide-backdrop": "",
      "content-class": "shadow",
      "centered": "",
      "ok-only": "",
      "hide-footer": "",
      "hide-header": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "ok-variant": "dark"
    }
  }, [_c('p', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "my-4"
  }, [_vm._v(".")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eea27af","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/campanhas/RetencaoOnline.vue
// module id = 742
// module chunks = 7